import request from '@/utils/request'

// 查询列表
export function apiMdmItemMaintenanceFinishedProductList (query) {
  return request({
    url: '/mdm/mdmItemMaintenance/finishedProductList',
    method: 'get',
    params: query
  })
}

// 导出成品属性维列表V2
export function apiMdmItemMaintenanceFinishedProductExport (data) {
  return request({
    url: '/mdm/mdmItemMaintenance/v2/finishedProductExport',
    method: 'post',
    data: data
  })
}

// 成品属性维护界面修改
export function apiMdmItemMaintenanceFinishedProductEdit (data) {
  return request({
    url: '/mdm/mdmItemMaintenance/finishedProductEdit',
    method: 'put',
    data: data
  })
}
